import React from "react";
import { Configure, Index } from "react-instantsearch";
import "instantsearch.css/themes/satellite.css";
import AlgoliaResults from "./AlgoliaResults";
import MobileRefinementsButton from "./MobileRefinementsButton";
import Filters from "./Filters";
import CustomPagination from "./CustomPagination";
import CustomSortBy from "./CustomSortBy";
import AlgoliaSuggestions from "./AlgoliaSuggestions";
import CustomCurrentRefinements from "./CustomCurrentRefinements";
import { CustomCurrentRefinementsProps } from "../utils/CustomCurrentRefinementsProps";
import { AlgoliaSearchResultsProps } from "./types/AlgoliaSearchResultsProps";
import CustomDataBanner from "./CustomDataBanner";
import { userTokenForPageLoad } from "../utils/UserToken";

const AlgoliaSearchResults = ({
  scrollToTop,
  indexName,
  disabledFilters = [],
  suggestionIndexName,
  pageLinks = [],
}: AlgoliaSearchResultsProps) => {
  const sortByItems = window.__litium.algoliaSettings.sortByItems;
  const customCurrentRefinements = (
    <CustomCurrentRefinements
      {...CustomCurrentRefinementsProps(disabledFilters)}
    />
  );

  return (
    <div className="algolia-search-results">
      {suggestionIndexName && (
        <Index indexName={suggestionIndexName}>
          <Configure clickAnalytics={true} userToken={userTokenForPageLoad} page={0} />
          <AlgoliaSuggestions pageLinks={pageLinks} />
        </Index>
      )}
      <div className="algolia-search-results__results">
        <div className="algolia-search-results__results__side-container">
          <div
            className="algolia-search-results__results__side-container__inner"
            data-algolia-insights-filters
          >
            <Filters disabledFilters={disabledFilters} openedOnInit={true} />
          </div>
        </div>
        <div className="algolia-search-results__results__main-container">
          <div className="algolia-search-results__results__status algolia-search-results__mobile-padding">
            <div className="algolia-search-results__results__status__refinements">
              {customCurrentRefinements}
            </div>
            <div className="algolia-search-results__results__status__mobile-refinements-button-container">
              <MobileRefinementsButton disabledFilters={disabledFilters}>
                <div className="algolia-sidemenu-container">
                  {customCurrentRefinements}
                  <div className="algolia-sidemenu-container__row algolia-sidemenu-container__row--divider"></div>
                  <div className="algolia-sidemenu-container__row algolia-sidemenu-container__row--filters">
                    <Filters
                      disabledFilters={disabledFilters}
                      openedOnInit={true}
                    />
                  </div>
                </div>
              </MobileRefinementsButton>
            </div>
            {sortByItems.length > 0 && (
              <div className="algolia-search-results__results__status__sort-by-container">
                <CustomSortBy items={sortByItems} />
              </div>
            )}
          </div>
          <CustomDataBanner />
          <div
            className="algolia-search-results__results__hits-container"
            data-insights-index={indexName}
          >
            <AlgoliaResults />
          </div>
          <div className="algolia-search-results__results__pagination-container">
            <CustomPagination padding={2} onPageChange={scrollToTop} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlgoliaSearchResults;
